import React, { useMemo } from 'react';
import { TrendingUp } from 'lucide-react';
import styles from './ChatStarters.module.css';
import logger from '../../../logging/logger';
import { CHAT_STARTER_PROMPTS, type ChatStarterPrompt } from './chatStarterPrompts';

interface ChatStartersProps {
  onStarterClick: (prompt: string) => void;
  isFirstTimeUser?: boolean;
}

const STARTER_PROMPT_COUNT = 4;

const getRandomPrompts = (prompts: ChatStarterPrompt[], count: number): ChatStarterPrompt[] => {
  const shuffled = [...prompts];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[i]];
  }
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

const ChatStarters: React.FC<ChatStartersProps> = ({ onStarterClick, isFirstTimeUser = false }) => {
  const starterPrompts = useMemo(
    () => getRandomPrompts(CHAT_STARTER_PROMPTS, STARTER_PROMPT_COUNT),
    [],
  );

  const handleClick = (prompt: string) => {
    logger.info('🎯 ChatStarters: Button clicked with prompt:', prompt);
    onStarterClick(prompt);
  };

  const headerText = isFirstTimeUser 
    ? "Get started with xquant"
    : "What would you like to explore?";

  return (
    <div className={styles.startersContainer}>
      <div className={styles.header}>
        <TrendingUp className={styles.sparkleIcon} />
        <h3 className={styles.title}>{headerText}</h3>
      </div>
      
      <div className={styles.startersGrid}>
        {starterPrompts.map((prompt) => {
          const PromptIcon = prompt.icon;
          return (
            <button
              key={prompt.prompt}
              className={styles.starterCard}
              onClick={() => handleClick(prompt.prompt)}
            >
              <div className={styles.starterTitle}>
                <PromptIcon className={styles.starterIcon} aria-hidden="true" />
                <span className={styles.starterTitleText}>{prompt.prompt}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { ChatStarters };
